import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteOrganizationMutation } from "../../services/appln";

export default function DeleteOrganization(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeleteOrganizationMutation}
      deleteArgs={{ id: props.id }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteOrganizationTitle}
      confirmationDialogMsg={strings.deleteOrganizationConfirmation}
      errorDialogTitle={strings.deleteOrganizationFailedTitle}
      errorDialogMsg={strings.deleteOrganizationFailedMsg}
    />
  );
}
